import React from 'react'
import GhostButton from '../../Buttons/GhostButton'
import { ReactComponent as PlusIcon } from '../../../images/icons/plus.svg'
import { useFormContext } from 'react-hook-form'
import { Vendor } from '../../../lib/types/Vendor'
import { getImageURL } from '../../../lib/utils/getImageURL'
import { ReactComponent as LinkIcon } from '../../../images/icons/connect_link_icon.svg'
import { useModal } from '../../useModal'
import { Button } from '@demandlocal/components'

type Props = {
  vendor: Vendor
  disabled?: boolean
}

export const CDKInstructions = (): JSX.Element => {
  const { closeModal } = useModal()
  return (
    <div className={'flex flex-1 flex-col px-12 pt-12 font-Spartan h-full overflow-auto'}>
      <div className={'flex flex-1 flex-col overflow-auto gap-4'}>
        <div className={'font-bold text-blue-primary pl-12 text-3xl'}>
          Connecting to CDK
        </div>
        <div className={'flex pl-12'}>
          <span>Navigate to the following link and click activate</span>
          <a
            href={
              'https://marketplace.fortellis.io/solutions/LinkOne/linkone-cdk?id=86780009-4382-461d-a388-5f25daa41da1'
            }
            className={
              'ignore-external-link-icon py-2 px-3 ml-2 rounded text-white font-Spartan font-bold h-8 flex flex-row items-center justify-center bg-primary-persian-blue/10'
            }
            target={'_blank'}
            rel={'noreferrer'}>
            <LinkIcon stroke={'#0932C2'} fill={'#0932C2'} className={'w-4 h-6'} />
          </a>
        </div>

        <div className={'flex pl-12'}>
          <img src={getImageURL('images/customers_upload/cdk_instructions.png')} />
        </div>
      </div>
      <div className={'h-20 items-center flex w-full justify-start border-t-2 py-4 mt-4'}>
        <Button
          variant="secondary"
          onClick={(e) => {
            e.preventDefault()
            closeModal()
          }}>
          Close
        </Button>
      </div>
    </div>
  )
}

const ConnectedSourceCDKFiSales = ({ vendor, disabled }: Props): JSX.Element => {
  const { setValue } = useFormContext()
  const { handleModal } = useModal()

  return (
    <div key={vendor.id} className={'flex items-center justify-between'}>
      <div className={'flex items-center gap-3 flex-1'}>
        <div className={'flex items-center justify-center'}>
          <div className={'w-8 h-8 rounded-full flex'}>
            <img
              src={getImageURL(`images/vendors/${vendor.logo}`)}
              className={'object-contain'}
            />
          </div>
        </div>
        <span
          className={`font-bold text-base text-blue-primary flex-1 ${
            (disabled || !vendor.connected) && 'opacity-50'
          }`}>
          {vendor.name}
        </span>

        {!disabled && (
          <GhostButton
            onClick={(e) => {
              e.preventDefault()
              if (vendor.connected) setValue?.(`vendor_${vendor.id}`, [{}])
            }}>
            {vendor.connected ? (
              <PlusIcon className={'w-4 h-6 stroke-primary-persian-blue '} />
            ) : (
              <LinkIcon
                stroke={'#0932C2'}
                fill={'#0932C2'}
                className={'w-4 h-6'}
                onClick={() => handleModal(<CDKInstructions />)}
              />
            )}
          </GhostButton>
        )}
      </div>
    </div>
  )
}

export default ConnectedSourceCDKFiSales
